/** Drain the live queue, including edits queued while an earlier save is in flight. */
export async function awaitDocumentSaves(
	chain: { current: Promise<void> },
	isCurrent: () => boolean,
	hasFailedAnswers: () => boolean,
): Promise<void> {
	const assertCurrent = () => {
		if (!isCurrent()) throw new Error('Intake changed. Open the intended intake and create the document again.');
	};
	assertCurrent();
	let pending: Promise<void>;
	do {
		pending = chain.current;
		try {
			await pending;
		} catch {
			throw new Error('Document was not created because an answer was not saved. Save the answer successfully before creating a document.');
		}
		assertCurrent();
	} while (pending !== chain.current);
	if (hasFailedAnswers())
		throw new Error('Document was not created because an answer was not saved. Save the answer successfully before creating a document.');
}
